import React from "react";

export default function ProductBehaviourSection({ form, handleChange }) {
  return (
    <>
      <div className="md:col-span-2">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          Item Behaviour
        </h4>
      </div>

      <div className="rounded-xl border border-slate-200 p-3">
        <label className="flex items-start gap-3">
          <input
            type="checkbox"
            name="requires_photo_upload"
            checked={form.requires_photo_upload}
            onChange={handleChange}
            className="mt-0.5 h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-900"
          />
          <div>
            <div className="text-sm font-medium text-slate-900">
              Requires Customer Photo Upload
            </div>
            <p className="mt-0.5 text-xs text-slate-500">
              Enable this only if the customer must upload their own image when
              ordering this item.
            </p>
          </div>
        </label>
      </div>

      <div className="rounded-xl border border-slate-200 p-3">
        <label className="flex items-start gap-3">
          <input
            type="checkbox"
            name="allows_custom_text"
            checked={form.allows_custom_text}
            onChange={handleChange}
            className="mt-0.5 h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-900"
          />
          <div>
            <div className="text-sm font-medium text-slate-900">
              Allows Custom Text
            </div>
            <p className="mt-0.5 text-xs text-slate-500">
              Enable this if customers can enter text for this item.
            </p>
          </div>
        </label>
      </div>

      {form.requires_photo_upload && (
        <div>
          <label className="mb-1.5 block text-sm font-medium text-slate-700">
            Customer Photo Upload Limit
          </label>
          <input
            type="number"
            min="1"
            max="10"
            name="max_uploads"
            value={form.max_uploads}
            onChange={handleChange}
            className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-slate-900"
            placeholder="1"
          />
          <p className="mt-1.5 text-xs text-slate-500">
            Enter how many photos the customer can upload, up to 10.
          </p>
        </div>
      )}

      {form.allows_custom_text && (
        <>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-slate-700">
              Custom Text Label
            </label>
            <input
              type="text"
              name="custom_text_label"
              value={form.custom_text_label}
              onChange={handleChange}
              className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-slate-900"
              placeholder="e.g. Add your message"
            />
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-medium text-slate-700">
              Custom Text Max Length
            </label>
            <input
              type="number"
              min="1"
              name="custom_text_max_length"
              value={form.custom_text_max_length}
              onChange={handleChange}
              className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-slate-900"
              placeholder="e.g. 50"
            />
          </div>
        </>
      )}
    </>
  );
}